const ROLE = {
    BLOCK_ROLE: 0,
    RENDER_ROLE: 2,
    REMOVE_LOGO_ROLE: 3
}

export default ROLE